var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nonodata"}},[_c('img',{attrs:{"src":_vm.$store.state.csr.mainLogoPic,"width":"100"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$store.state.csr.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a764e46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/nodata/index.vue
// module id = null
// module chunks = 